// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__9xTjG","content":"ManualTimeModal_content__yjzeT"};